module.exports = __webpack_public_path__ + "img/green-graph.a695149d.svg";